import { Role } from "../../helpers/role";

export const AcquisitionRoutes = [
  {
    name: "AdminAcquisition",
    path: `/${Role.Acquisition}`,
    redirect: "/",
    component: () => import("@/layouts/Layout"),
    children: [
      {
        name: "Dashboard",
        path: "/",
        component: () => import("@/views/acquisition/Dashboard"),
        meta: {
          authorize: [Role.Acquisition],
        },
      },

      {
        name: "ViewActiveSession",
        path: "view-active-session",
        component: () =>
          import("@/views/acquisition/components/summaries/ActiveSessionList"),
        meta: {
          authorize: [Role.Acquisition],
        },
      },

      {
        name: "ViewDormantList",
        path: "dormant-list",
        component: () =>
          import("@/views/acquisition/components/summaries/DormantList"),
        meta: {
          authorize: [Role.Acquisition],
        },
      },

      {
        name: "PendingForInstallationList",
        path: "pending-for-installation-list",
        component: () =>
          import(
            "@/views/acquisition/components/summaries/PendingForInstallationList"
          ),
        meta: {
          authorize: [Role.Acquisition],
        },
      },

      {
        name: "TodaySignupList",
        path: "today-signup-list",
        component: () =>
          import("@/views/acquisition/components/summaries/TodaySignupList"),
        meta: {
          authorize: [Role.Acquisition],
        },
      },

      {
        name: "TodayActivationList",
        path: "today-activation-list",
        component: () =>
          import(
            "@/views/acquisition/components/summaries/TodayActivationList"
          ),
        meta: {
          authorize: [Role.Acquisition],
        },
      },

      {
        name: "MonthToDateList",
        path: "month-activation-list",
        component: () =>
          import("@/views/acquisition/components/summaries/MonthToDateList"),
        meta: {
          authorize: [Role.Acquisition],
        },
      },

      {
        name: "NoNap",
        path: "no-nap",
        component: () =>
          import("@/views/acquisition/components/signups_components/NoNap"),
        meta: {
          authorize: [Role.Acquisition],
        },
      },

      {
        name: "ForInstallation",
        path: "for-installation",
        component: () =>
          import(
            "@/views/acquisition/components/signups_components/ForInstallation"
          ),
        meta: {
          authorize: [Role.Acquisition],
        },
      },

      {
        name: "PartialPayLater",
        path: "partial-pay-later",
        component: () =>
          import(
            "@/views/acquisition/components/signups_components/PartialPayLater"
          ),
        meta: {
          authorize: [Role.Acquisition],
        },
      },

      {
        name: "ActivatedList",
        path: "activation-per-area",
        component: () => import("@/views/acquisition/ActivatedList"),
        meta: {
          authorize: [Role.Acquisition],
        },
      },

      {
        name: "SubscriberActivation",
        path: "subscriber-activation",
        component: () => import("@/views/acquisition/SubscriberActivation"),
        meta: {
          authorize: [Role.Acquisition],
        },
      },
      {
        name: "Dealers",
        path: "dealers",
        component: () => import("@/views/acquisition/Dealers"),
        meta: {
          authorize: [Role.Acquisition],
        },
      },

      {
        name: "Retailers",
        path: "retailers",
        component: () => import("@/views/acquisition/Retailers"),
        meta: {
          authorize: [Role.Acquisition],
        },
      },
      {
        name: "SalesAgent",
        path: "sales-agent",
        component: () => import("@/views/acquisition/SalesAgent"),
        meta: {
          authorize: [Role.Acquisition],
        },
      },

      {
        name: "Subscribers",
        path: "subscribers",
        component: () => import("@/views/acquisition/Subscribers"),
        meta: {
          authorize: [Role.Acquisition],
        },
      },

      {
        name: "MonthlySalesReport",
        path: "monthly-sales-report",
        component: () => import("@/views/acquisition/MonthlySalesReport"),
        meta: {
          authorize: [Role.Acquisition],
        },
      },

      {
        name: "DailySalesReport",
        path: "daily-sales-report",
        component: () => import("@/views/acquisition/DailySalesReport"),
        meta: {
          authorize: [Role.Acquisition],
        },
      },

      {
        name: "SkuSalesReport",
        path: "sku-sales-report",
        component: () => import("@/views/acquisition/SkuSalesReport"),
        meta: {
          authorize: [Role.Acquisition],
        },
      },

      {
        name: "JoList",
        path: "jo-list",
        component: () => import("@/views/acquisition/JoList"),
        meta: {
          authorize: [Role.Acquisition],
        },
      },

      {
        name: "JoApproved",
        path: "jo-approved",
        component: () => import("@/views/acquisition/JoApproved"),
        meta: {
          authorize: [Role.Acquisition],
        },
      },

      {
        name: "PrepaidFiberCustomer",
        path: "prepaid-fiber-customer",
        component: () => import("@/views/acquisition/PrepaidFiberCustomer"),
        meta: {
          authorize: [Role.Acquisition],
        },
      },

      {
        name: "PortReservation",
        path: "port-reservation",
        component: () => import("@/views/acquisition/PortReservation"),
        meta: {
          authorize: [Role.Acquisition],
        },
      },

      {
        name: "IbasHome",
        path: "ibas-home",
        component: () => import("@/views/acquisition/IbasHome"),
        meta: {
          authorize: [Role.Acquisition],
        },
      },

      {
        name: "IbasForInstallation",
        path: "ibas-for-installation",
        component: () => import("@/views/acquisition/IbasForInstallation"),
        meta: {
          authorize: [Role.Acquisition],
        },
      },

      {
        name: "DistributorActivation",
        path: "distributor-activation",
        component: () => import("@/views/acquisition/DistributorActivation"),
        meta: {
          authorize: [Role.Acquisition],
        },
      },

      {
        name: "OnlineForInstallation",
        path: "online-for-installation",
        component: () => import("@/views/acquisition/OnlineForInstallation"),
        meta: {
          authorize: [Role.Acquisition],
        },
      },
      {
        name: "OnlineForInstallationPaid",
        path: "online-for-installation-paid",
        component: () => import("@/views/acquisition/OnlineForInstallationPaid"),
        meta: {
          authorize: [Role.Acquisition],
        },
      },
      {
        name: "OnlineForConfirmation",
        path: "online-for-confirmation",
        component: () => import("@/views/acquisition/OnlineForConfirmation"),
        meta: {
          authorize: [Role.Acquisition],
        },
      },

      {
        name: "OnlinePastDue",
        path: "online-past-due",
        component: () => import("@/views/acquisition/OnlinePastDue"),
        meta: {
          authorize: [Role.Acquisition],
        },
      },
      {
        name: "OnlineInstalled",
        path: "online-installed",
        component: () => import("@/views/acquisition/OnlineInstalled"),
        meta: {
          authorize: [Role.Acquisition],
        },
      },

      {
        name: "DistributorSales",
        path: "distributor-sales",
        component: () => import("@/views/acquisition/DistributorSales"),
        meta: {
          authorize: [Role.Acquisition],
        },
      },

      {
        name: "CODHome",
        path: "online-home",
        component: () => import("@/views/acquisition/CodHome"),
        meta: {
          authorize: [Role.Acquisition],
        },
      },
      {
        name: "OnlineCancelled",
        path: "online-cancelled",
        component: () => import("@/views/acquisition/OnlineCancelled"),
        meta: {
          authorize: [Role.Acquisition],
        },
      },

      {
        name: "JoNumberList",
        path: "jo-number-list",
        component: () => import("@/views/acquisition/JoNumberList"),
        meta: {
          authorize: [Role.Acquisition],
        },
      },
      {
        name: "jocreated",
        path: "jo-created",
        component: () => import("@/views/acquisition/JoCreated"),
        meta: {
          authorize: [Role.Acquisition],
        },
      },
    ],
  },
];
